// import React from 'react';
// import { Helmet } from 'react-helmet';
// import '../css/privacy-policy.css';

// const PrivacyPolicy = () => {
//   return (
//     <div>
//       <Helmet>
//         <title>Privacy Policy | Pune Corporate Cars India Private Limited</title>
//       </Helmet>
//  <section
//         className="breadcrumb-section"
//         style={{ backgroundImage: "url(/images/background/inner-banner-bg.jpg)" }}
//       >
//         <div className="container">
//           <div className="banner-content">
//             <h1>Privacy Policy</h1>
//           </div>
//         </div>
//       </section>

          

    

//       <section className="privacy-policy">
//         <div className="container px-0">
//           <div className="row g-0">
//             <div className="col-12 col-md-7">
//               <h3 className="title">Privacy Policy</h3>

//               <p>
//                 At <strong>Pune Corporate Cars India Private Limited</strong>, we are committed to protecting your privacy and safeguarding your personal information. This Privacy Policy explains how we collect, use, disclose, and protect your information when you use our corporate transportation services.
//               </p>

//               <div className="section">
//                 <p className="highlight darkcolor">Information We Collect:</p>
//                 <p className="highlight darkcolor">1. Personal Information:</p>
//                 <p>
//                   When you book our corporate car services, we may collect personal information such as your name, contact details, company details, payment information, and travel preferences.
//                 </p>

//                 <p className="highlight darkcolor">2. Usage Information:</p>
//                 <p>
//                   We may collect data about how you interact with our website, mobile app, or booking platform, including IP address, device information, and pages visited.
//                 </p>

//                 <p className="highlight darkcolor">3. Location Information:</p>
//                 <p>
//                   With your consent, we may collect your location to provide efficient pickup and drop-off services and optimize route planning.
//                 </p>
//               </div>

//               <div className="section">
//                 <p className="highlight darkcolor">How We Use Your Information:</p>
//                 <p className="highlight darkcolor">1. To Provide Services:</p>
//                 <p>
//                   We use your information to manage bookings, assign vehicles, and ensure smooth corporate transportation.
//                 </p>

//                 <p className="highlight darkcolor">2. To Improve Services:</p>
//                 <p>
//                   We analyze user feedback and usage data to enhance service quality, fleet management, and customer experience.
//                 </p>

//                 <p className="highlight darkcolor">3. For Communication:</p>
//                 <p>
//                   Your contact information may be used to send booking confirmations, service updates, and important notifications.
//                 </p>

//                 <p className="highlight darkcolor">4. For Marketing:</p>
//                 <p>
//                   With your consent, we may send promotional offers and updates about our corporate services.
//                 </p>
//               </div>

//               <div className="section">
//                 <p className="highlight darkcolor">Information Sharing and Disclosure:</p>
//                 <p className="highlight darkcolor">1. Third-Party Service Providers:</p>
//                 <p>
//                   We may share your information with trusted service providers who assist in fleet management, payment processing, or customer service.
//                 </p>

//                 <p className="highlight darkcolor">2. Legal Compliance:</p>
//                 <p>
//                   Your information may be disclosed as required by law or to protect our rights, safety, or that of others.
//                 </p>
//               </div>

//               <div className="section">
//                 <p className="highlight darkcolor">Data Security:</p>
//                 <p>
//                   We implement industry-standard security measures to protect your personal data. However, no method of transmission is completely secure.
//                 </p>

//                 <p className="highlight darkcolor">Your Rights:</p>
//                 <p>
//                   You have the right to access, update, or delete your personal information. You can also opt out of marketing communications at any time.
//                 </p>

//                 <p className="highlight darkcolor">Changes to this Privacy Policy:</p>
//                 <p>
//                   We may update this Privacy Policy periodically. Changes take effect immediately upon posting on our website.
//                 </p>
//               </div>
//             </div>
//           </div>

//           <div className="contact-info">
//             <h2>Contact Us</h2>
//             <p>For any queries regarding our privacy policy, feel free to reach out:</p>
//             <ul>
//               <li><b>Phone:</b> <a href="tel:+919822136667">+91 9822136667</a></li>
//               <li><b>Email:</b> <a href="mailto:info@punecorporatecars.com">info@punecorporatecars.com</a></li>
//             </ul>
//           </div>
//         </div>
//       </section>
//     </div>
//   );
// };

// export default PrivacyPolicy;





import React from 'react';
import { Helmet } from 'react-helmet';
import '../css/privacy-policy.css';

const PrivacyPolicy = () => {
  return (
    <div>
      <Helmet>
        <title>Privacy Policy | Pune Corporate Cars India Private Limited</title>
      </Helmet>

      <section
        className="breadcrumb-section"
        style={{ backgroundImage: "url(/images/background/inner-banner-bg.jpg)" }}
      >
        <div className="container">
          <div className="banner-content">
            <h1>Privacy Policy</h1>
          </div>
        </div>
      </section>

      <section className="privacy-policy">
        <div className="container px-0">
          <div className="row g-0">
            <div className="col-12 col-md-7">
              <h3 className="title">Privacy Policy</h3>

              <p>
                At <strong>Pune Corporate Cars India Private Limited</strong>, we are committed to protecting the privacy and personal data of our customers, corporate clients, drivers, vendors, website visitors, and all other stakeholders. This Privacy Policy explains how we collect, use, disclose, store, and protect your information when you use our services, website, mobile applications, or otherwise interact with us.
              </p>

              <div className="section">
                <p className="highlight darkcolor">1. Scope of This Policy</p>
                <p>This Privacy Policy applies to:</p>
                <ul>
                  <li>Visitors to our website and digital platforms</li>
                  <li>Corporate and individual customers using our car rental and chauffeur-driven services</li>
                  <li>Drivers, vendors, and service partners</li>
                  <li>Individuals who communicate with us via email, phone, forms, or other channels</li>
                </ul>
              </div>

              <div className="section">
                <p className="highlight darkcolor">2. Information We Collect</p>

                <p className="highlight darkcolor">a) Personal Information</p>
                <ul>
                  <li>Name, designation, company name</li>
                  <li>Email address, phone number</li>
                  <li>Billing and payment details</li>
                  <li>Government-issued identification details (where required)</li>
                </ul>

                <p className="highlight darkcolor">b) Service & Usage Information</p>
                <ul>
                  <li>Trip details such as pickup and drop locations, dates, and duration</li>
                  <li>Vehicle and chauffeur assignment details</li>
                  <li>Feedback, complaints, and support requests</li>
                </ul>

                <p className="highlight darkcolor">c) Technical Information</p>
                <ul>
                  <li>IP address, browser type, and device information</li>
                  <li>Website usage data, cookies, and log files</li>
                </ul>
              </div>

              <div className="section">
                <p className="highlight darkcolor">3. Purpose of Data Collection</p>
                <ul>
                  <li>Provide and manage corporate and individual car rental services</li>
                  <li>Process bookings, invoices, and payments</li>
                  <li>Communicate service confirmations, updates, and support</li>
                  <li>Improve service quality, safety, and customer experience</li>
                  <li>Comply with legal, regulatory, and contractual obligations</li>
                </ul>
              </div>

              <div className="section">
                <p className="highlight darkcolor">4. Legal Basis for Processing</p>
                <ul>
                  <li>Your consent</li>
                  <li>Performance of a contract or service agreement</li>
                  <li>Compliance with applicable laws and regulations</li>
                  <li>Legitimate business interests such as service improvement and fraud prevention</li>
                </ul>
              </div>

              <div className="section">
                <p className="highlight darkcolor">5. Data Sharing & Disclosure</p>
                <p>We do not sell or rent your personal information. Data may be shared only with:</p>
                <ul>
                  <li>Authorized chauffeurs, vendors, and service partners</li>
                  <li>Payment gateways and financial institutions</li>
                  <li>Government or regulatory authorities when legally required</li>
                  <li>Professional advisors under confidentiality obligations</li>
                </ul>
              </div>

              <div className="section">
                <p className="highlight darkcolor">6. Data Security</p>
                <p>
                  We implement reasonable technical and organizational measures to protect personal data against unauthorized access, loss, misuse, or alteration. Access is restricted to authorized personnel only.
                </p>
              </div>

              <div className="section">
                <p className="highlight darkcolor">7. Data Retention</p>
                <p>
                  Personal information is retained only as long as necessary to fulfill the purposes outlined in this policy or meet legal, regulatory, or contractual requirements. Data is securely deleted or anonymized thereafter.
                </p>
              </div>

              <div className="section">
                <p className="highlight darkcolor">8. Cookies & Tracking Technologies</p>
                <p>
                  Our website may use cookies to enhance user experience and analyze website performance. You may control or disable cookies through your browser settings.
                </p>
              </div>

              <div className="section">
                <p className="highlight darkcolor">9. Your Rights</p>
                <ul>
                  <li>Access your personal data</li>
                  <li>Request correction or updates</li>
                  <li>Withdraw consent where applicable</li>
                  <li>Request deletion of data subject to legal obligations</li>
                </ul>
              </div>

              <div className="section">
                <p className="highlight darkcolor">10. Compliance with Indian Laws</p>
                <p>
                  We comply with applicable Indian data protection laws, including the Information Technology Act, 2000, IT Rules 2011, and the Digital Personal Data Protection Act, 2023 (as applicable).
                </p>
              </div>

              <div className="section">
                <p className="highlight darkcolor">11. International Data Protection</p>
                <p>
                  For international clients, including those in the European Union, personal data is processed in accordance with applicable global data protection regulations such as GDPR, including safeguards for cross-border transfers.
                </p>
              </div>

              <div className="section">
                <p className="highlight darkcolor">12. Changes to This Policy</p>
                <p>
                  This Privacy Policy may be updated periodically. Any changes will be posted on our website with an updated effective date.
                </p>
              </div>

              <p><strong>Effective Date:</strong> 01 April 2026</p>
            </div>
          </div>

          {/* <div className="contact-info">
            <h2>Contact Us</h2>
            <p>For any questions or requests regarding this Privacy Policy:</p>
            <ul>
              <li><b>Email:</b> <a href="mailto:info@punecorporatecars.com">info@punecorporatecars.com</a></li>
            </ul>
          </div> */}


<div className="contact-info">
  <h2>Contact Us</h2>

  {/* Reservations / Booking Helpdesk */}
  <h3>📞 Reservations | Booking Helpdesk (24×7)</h3>
  <ul>
    <li>
      <b>Operation Help Desk:</b>{' '}
      <a href="tel:+919822943334">+91 9822943334</a> /{' '}
      <a href="tel:+919405644855">+91 9405644855</a>
    </li>
    <li>
      <b>Email:</b>{' '}
      <a href="mailto:reservations@punecorporatecars.com">
        reservations@punecorporatecars.com
      </a>
    </li>
  </ul>

  {/* Corporate Sales */}
  <h3>💼 Corporate Sales (Pan India)</h3>
  <ul>
    <li>
      <b>Email:</b>{' '}
      <a href="mailto:sales@punecorporatecars.com">
        sales@punecorporatecars.com
      </a>
    </li>
    <li>
      <b>Email:</b>{' '}
      <a href="mailto:sanjay.nalawade@punecorporatecars.com">
        sanjay.nalawade@punecorporatecars.com
      </a>
    </li>
    <li>
      <b>Mobile:</b>{' '}
      <a href="tel:+919822136667">+91 9822136667</a> /{' '}
      <a href="tel:+917350959600">+91 7350959600</a>
    </li>
  </ul>
</div>




        </div>
      </section>
    </div>
  );
};

export default PrivacyPolicy;
